import axios from "axios";
import { API_URL } from "../config";
import authService from "./auth";

const autoInfracaoService = {
  listar: async (filtros) => {
    try {
      const params = new URLSearchParams();
      if (filtros.numero) params.append("numero", filtros.numero);
      if (filtros.tipo) params.append("tipo", filtros.tipo);
      if (filtros.dataInicial)
        params.append("data_inicial", filtros.dataInicial);
      if (filtros.dataFinal) params.append("data_final", filtros.dataFinal);

      const response = await axios.get(`${API_URL}/auto-infracao/`, {
        headers: authService.getAuthHeader(),
        params,
      });
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || { detail: "Erro ao buscar autos de infração" }
      );
    }
  },

  criar: async (dados) => {
    try {
      const response = await axios.post(`${API_URL}AutoDeInfracao`, dados, {
        headers: authService.getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || { message: "Erro ao criar auto de infração" }
      );
    }
  },

  atualizar: async (dados) => {
    try {
      const response = await axios.put(`${API_URL}AutoDeInfracao`, dados, {
        headers: authService.getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Erro ao atualizar auto de infração",
        }
      );
    }
  },

  obter: async (id) => {
    try {
      const response = await axios.get(`${API_URL}AutoDeInfracao/${id}`, {
        headers: authService.getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || { message: "Erro ao obter auto de infração" }
      );
    }
  },

  deletar: async (id) => {
    try {
      const response = await axios.delete(`${API_URL}AutoDeInfracao/${id}`, {
        headers: authService.getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || { message: "Erro ao deletar auto de infração" }
      );
    }
  },

  listarComFiltro: async (
    numero,
    tipo,
    dataInicial,
    dataFinal,
    pageNumber = 1,
    pageSize = 100
  ) => {
    try {
      const params = new URLSearchParams();
      if (numero) params.append("numero", numero);
      if (tipo) params.append("tipo", tipo);
      if (dataInicial) params.append("data_inicial", dataInicial);
      if (dataFinal) params.append("data_final", dataFinal);
      params.append("page_number", pageNumber);
      params.append("page_size", pageSize);

      const response = await axios.get(
        `${API_URL}AutoDeInfracao/filtrar?${params.toString()}`,
        {
          headers: authService.getAuthHeader(),
        }
      );
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Erro ao buscar autos de infração com filtro",
        }
      );
    }
  },

  listarMeusAutos: async (pageNumber = 1, pageSize = 10) => {
    try {
      const response = await axios.get(
        `${API_URL}AutoDeInfracao/usuario/meus-autos`,
        {
          headers: authService.getAuthHeader(),
          params: {
            pageNumber,
            pageSize,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Erro ao buscar meus autos de infração",
        }
      );
    }
  },
};

export default autoInfracaoService;
